<template>
    <TopNav></TopNav>
    <h1>Comparați cutremurele</h1>
    <fieldset>
        <legend>Comparați cutremurele</legend>
        <label for="a" title="primul cutremur">Cutremurul A: </label> <input type="number" v-model.number="earthquakea" id="a" step="any" min="0"> <span title="scara magnitudinii momentului">M<sub>w</sub></span>
        <br>
        <label for="b" title="al doilea cutremur">Cutremurul B: </label> <input type="number" v-model.number="earthquakeb" id="b" step="any" min="0"> <span title="scara magnitudinii momentului">M<sub>w</sub></span>
        <br><br>
        Diferența de vibrații este de <span class="blue">{{ shake() }}</span> ori mai mare.<br><br>
        Diferența de energie este de <span class="blue">{{ energy() }}</span> ori mai mare.
    </fieldset>
</template>

<script>
import TopNav from './components/TopNav.vue'

export default {
    name: 'EarthquakeComparator',
    data() {
        return {
            earthquakea: 6,
            earthquakeb: 7,
        }
    },
    components: {
        TopNav
    },
    methods: {
        shake: function () {
            const formatter = new Intl.NumberFormat('ro-RO', {
                maximumFractionDigits: 5
            });
            let shaking = 0;
            let diff = this.earthquakea - this.earthquakeb;
            let absolut = Math.abs(diff);
            shaking = Math.pow(10, absolut);
            const shakingNumber = Number(shaking);
            return formatter.format(shakingNumber);
        },
        energy: function () {
            const formatter = new Intl.NumberFormat('ro-RO', {
                maximumFractionDigits: 5
            });
            let shaking = 0;
            let diff = this.earthquakea - this.earthquakeb;
            let absolut = Math.abs(diff);
            shaking = Math.pow(10, absolut * 1.5);
            const shakingNumber = Number(shaking);
            return formatter.format(shakingNumber);
        },
    },
};
</script>

<style>
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 60px;
}

body {
    margin: 1em auto;
    margin-top: 0;
    max-width: 40em;
    font-family: Arial, Helvetica, sans-serif;
}

label {
    display: inline-block;
    width: 130px;
}

footer section a {
    margin: 20px;
}

.blue {
    color: blue;
}
</style>
